<template>
  <div class="mm-page-main">
    <div class="page-header">
      <div class="page-title">添加訂單</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>

    <div class="pagemain" v-loading="loading">
      <el-form ref="form" :model="form" label-width="120px" label-position="left">
        <div class="form-group" v-show="!nextbox">
          <div class="form-group-header">
            <div>
              <h3>基本資料</h3>
            </div>
            <div>訂單編號：保存後生成</div>
          </div>
          <div class="form-group-content">
            <div class="mm-row ">
              <div class="mm-item">
                <el-form-item label="建立部門" required>
                  <el-select class="elselect" v-model="form.sector_id" placeholder="請選擇">
                    <template v-for="item in sectorlist">
                      <el-option :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="mm-row ">

              <div class="mm-item">
                <el-form-item label="所屬門店" required>
                  <el-select class="elselect" v-model="form.store_id" placeholder="請選擇">
                    <template v-for="item in storelist">
                      <el-option :key="item.id" :label="item.short+' '+item.name" :value="item.id"></el-option>
                    </template>
                  </el-select>
                </el-form-item>

              </div>
            </div>
            <div class="mm-row">

              <div class="mm-item">
                <el-form-item label="訂單類別" required>
                  <el-radio-group v-model="form.ordertype">
                    <el-radio-button label="0">兌換</el-radio-button>
                    <el-radio-button label="1">匯款</el-radio-button>
                    <el-radio-button label="2">内部記賬</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" v-show="!nextbox">
          <div class="form-group-header">
            <div class="pctitle">
              <h3 class="mr15">指示人資料</h3>
              <span class="mr15">添加匯款人(如匯款人非指示人)</span>
            </div>

            <div>
              <el-button class="addren" v-if="form.is_remitter" type="success" icon="el-icon-plus" circle @click="form.is_remitter=false"></el-button>
              <el-button class="addren" v-if="!form.is_remitter" type="info" icon="el-icon-minus" circle @click="form.is_remitter=true"></el-button>
            </div>
          </div>
          <div class="form-group-content">

            <div class="mm-row">
              <div class="mm-col mm-row">
                <div class="mm-item">
                  <el-form-item label="會員類別" required>
                    <el-radio-group :disabled="form.client.id!=0" v-model="form.client.type">
                      <el-radio-button label="0">個人</el-radio-button>
                      <el-radio-button label="1">企業</el-radio-button>
                      <el-radio-button label="2">行家</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div>
                  <el-button type="primary" v-if="form.client.id==0" @click="dialogcustomerlist=true">選擇會員</el-button>
                  <el-button type="danger" v-if="form.client.id!=0" @click="customerinit(1)">清空會員</el-button>
                </div>
                <!-- 选择会员 -->

                <div class="chooseuserbox">
                  <el-dialog title="選擇會員" :visible.sync="dialogcustomerlist" width="90%" :close-on-click-modal="false">
                    <div v-if="dialogcustomerlist">
                      <customerlist :visible.sync="dialogcustomerlist" :customerData.sync="form.client"></customerlist>
                    </div>
                  </el-dialog>
                </div>

              </div>
            </div>

            <div :key="timer" class="mm-row-block">
              <div class="form-isheader-group">
                <div class="group-title">
                  <h3>基本資料</h3>
                </div>
                <div class="form-isheader-group-content" v-if="form.client.type==0">
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="電話號碼" required>
                        <el-input v-model="form.client.phone"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="會員姓名" required>
                        <el-input v-model="form.client.name"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item flex50">
                      <el-form-item label="英文名稱">
                        <el-input clearable v-model="form.client.ename"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item flex50">
                      <el-form-item label="稱謂">
                        <el-select class="elselect" v-model="form.client.appellations" clearable placeholder="請選擇" :popper-append-to-body="false">
                          <el-option :label="'先生'" :value="1"></el-option>
                          <el-option :label="'女士'" :value="2"></el-option>
                          <el-option :label="'小姐'" :value="3"></el-option>
                          <el-option :label="'太太'" :value="4"></el-option>
                          <el-option :label="'其他'" :value="0"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="國籍" required>
                        <countryselect :form="form.client"></countryselect>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="身份證或護照">
                        <el-input v-model="form.client.card"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="住址">
                        <el-input v-model="form.client.address"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="是否代理">
                        <el-switch style="display: block" v-model="form.client.agent" active-color="#13ce66" inactive-color="#ff4949" active-text="是" inactive-text="否" active-value="1" inactive-value="0">
                        </el-switch>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="form-isheader-group-content" v-if="form.client.type==1||form.client.type==2">
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="公司名稱" required>
                        <el-input v-model="form.client.name"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item flex50">
                      <el-form-item label="英文名稱">
                        <el-input clearable v-model="form.client.ename"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="公司編號">
                        <el-input v-model="form.client.company_num"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="商業登記號碼" required>
                        <el-input v-model="form.client.company_card"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="商業登記證號碼有效日期" required>
                        <el-date-picker v-model="form.client.company_card_date" type="date" placeholder="選擇日期" style="width:100%;">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="業務性質" required>
                        <el-input v-model="form.client.company_type"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="公司電話號碼" required>
                        <el-input v-model="form.client.phone"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="公司電郵">
                        <el-input v-model="form.client.email"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row " v-if="form.client.type==2">
                    <div class="mm-item">
                      <el-form-item label="MSO 編號" required>
                        <el-input v-model="form.client.mso_num"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row " v-if="form.client.type==2">
                    <div class="mm-item">
                      <el-form-item label="MSO有效日期" required>
                        <el-date-picker v-model="form.client.mso_num_date" type="date" placeholder="選擇日期" style="width:100%;">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </div>

              </div>
              <el-card class="box-card mb10" shadow="never" v-if="form.client.type==1||form.client.type==2">
                <div slot="header" class="clearfix">
                  <h3>股東 及 董事</h3>
                </div>
                <div class="text item">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                      <el-form-item label="股東姓名" required>
                        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                          <el-input v-model="form.client.stockholder[0].name"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                      <el-form-item label="董事姓名" required>
                        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                          <el-input v-model="form.client.director[0].name"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
              <el-card class="box-card mb10" shadow="never" v-if="form.client.type==1||form.client.type==2">
                <div slot="header" class="clearfix">
                  <h3>獲授權人</h3>
                </div>
                <div class="text item">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                      <el-form-item label="姓名" required>
                        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                          <el-input v-model="form.client.authorizer[0].name"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                      <el-form-item label="電話號碼" required>
                        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                          <el-input v-model="form.client.authorizer[0].phone"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>

                </div>
              </el-card>
              <div class="form-isheader-group">
                <div class="group-title">
                  <h3>會員文件</h3>
                </div>
                <div class="form-isheader-group-content">
                  <div v-if="form.client.type==1||form.client.type==2" class="notice" v-html="noticeContent"></div>
                  <uploadimage :oldImageUrlList.sync="form.client.customer_files_list" :imageUrlList.sync="form.client.customer_upload_list" listType="picture-card"></uploadimage>
                </div>
              </div>
              <div class="form-isheader-group">
                <div class="group-title">
                  <h3>審查結果 Name Screening Result</h3>
                  <div class="shengchabon" v-if="examineStatus()">
                    <el-input-number class="mr15 pcshow2" v-model="form.client.shengchascore" :min="0" :max="100" label="審查起始分數"></el-input-number>
                    <el-button @click="examine1" type="primary" plain>在線审查</el-button>
                  </div>
                </div>
                <div class="form-isheader-group-content">
                  <div style="margin-bottom: 20px;">
                    <div class="group-sub-title">
                      <h3>OFAC</h3>
                    </div>
                    <el-table empty-text="暫無數據" :data="form.client.examinedata" border :header-cell-style="{background:'#FAFAFA'}">
                      <el-table-column label="Name" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Name</div>
                          <span>{{scope.row.name}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Address" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Address</div>
                          <span>{{scope.row.address}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Type" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Type</div>
                          <span>{{scope.row.type}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Program(s)" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Program(s)</div>
                          <span>{{scope.row.program}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="List" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">List</div>
                          <span>{{scope.row.list}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Score" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Score</div>
                          <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                          <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                          <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Url" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Url</div>
                          <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Query Time" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Query Time</div>
                          <span>{{scope.row.addtime}}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div style="margin-bottom: 20px;">
                    <div class="group-sub-title">
                      <h3>UNSC</h3>
                    </div>
                    <el-table empty-text="暫無數據" :data="form.client.examinedataxml" border :header-cell-style="{background:'#FAFAFA'}">
                      <el-table-column label="Name" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Name</div>
                          <span>{{scope.row.name}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Type" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">type</div>
                          <span>{{scope.row.type}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Design" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">design</div>
                          <span>{{scope.row.design}}</span>
                        </template>
                      </el-table-column>

                      <el-table-column label="Date" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">date</div>
                          <span>{{scope.row.date}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Score" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Score</div>
                          <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                          <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                          <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Url" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Url</div>
                          <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Query Time" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Query Time</div>
                          <span>{{scope.row.addtime}}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div style="margin-bottom: 20px;" v-if="examineStatus()">
                    <el-image style="width: 148px; height: 148px" :src="form.client.examineimg" :preview-src-list="form.client.examineimglist">
                    </el-image>
                  </div>
                  <uploadimage :oldImageUrlList.sync="form.client.review_files_list" :imageUrlList.sync="form.client.review_upload_list" listType="picture-card"></uploadimage>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :key="timer2" class="form-group" v-show="!nextbox&&!form.is_remitter">
          <div class="form-group-header">
            <div>
              <h3>匯款人資料</h3>
            </div>
          </div>
          <div class="form-group-content">

            <div class="mm-row">
              <div class="mm-col mm-row">
                <div class="mm-item">
                  <el-form-item label="會員類別">
                    <el-radio-group :disabled="form.client2.id!=0" v-model="form.client2.type">
                      <el-radio-button label="0">個人</el-radio-button>
                      <el-radio-button label="1">企業</el-radio-button>
                      <el-radio-button label="2">行家</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div>
                  <el-button type="primary" v-if="form.client2.id==0" @click="dialogcustomerlist2=true">選擇會員</el-button>
                  <el-button type="danger" v-if="form.client2.id!=0" @click="customerinit(2)">清空會員</el-button>
                </div>
                <!-- 选择会员 -->
                <el-dialog title="選擇會員" :visible.sync="dialogcustomerlist2" width="90%" :close-on-click-modal="false">
                  <div v-if="dialogcustomerlist2">
                    <customerlist :visible.sync="dialogcustomerlist2" :customerData.sync="form.client2"></customerlist>
                  </div>
                </el-dialog>
              </div>
            </div>

            <div class="mm-row-block">
              <div class="form-isheader-group">
                <div class="group-title">
                  <h3>基本資料</h3>
                </div>
                <div class="form-isheader-group-content" v-if="form.client2.type==0">
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="電話號碼" required>
                        <el-input v-model="form.client2.phone"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="會員姓名" required>
                        <el-input v-model="form.client2.name"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="英文名稱">
                        <el-input clearable v-model="form.client2.ename"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="稱謂">
                        <el-select v-model="form.client2.appellations" clearable placeholder="請選擇" :popper-append-to-body="false">
                          <el-option :label="'先生'" :value="1"></el-option>
                          <el-option :label="'女士'" :value="2"></el-option>
                          <el-option :label="'小姐'" :value="3"></el-option>
                          <el-option :label="'太太'" :value="4"></el-option>
                          <el-option :label="'其他'" :value="0"></el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="國籍" required>
                        <countryselect :form="form.client2"></countryselect>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="身份證或護照">
                        <el-input v-model="form.client2.card"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="住址">
                        <el-input v-model="form.client2.address"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="是否代理">
                        <el-switch style="display: block" v-model="form.client2.agent" active-color="#13ce66" inactive-color="#ff4949" active-text="是" inactive-text="否" active-value="1" inactive-value="0">
                        </el-switch>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <div class="form-isheader-group-content" v-if="form.client2.type==1||form.client.type==2">
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="公司名稱">
                        <el-input v-model="form.client2.name"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item flex50">
                      <el-form-item label="英文名稱">
                        <el-input clearable v-model="form.client.ename"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="公司編號">
                        <el-input v-model="form.client2.company_num"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="商業登記號碼">
                        <el-input v-model="form.client2.company_card"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="商業登記證號碼有效日期">
                        <el-date-picker v-model="form.client2.company_card_date" type="date" placeholder="選擇日期" style="width:100%;">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="業務性質">
                        <el-input v-model="form.client2.company_type"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="公司電話號碼">
                        <el-input v-model="form.client2.phone"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row ">
                    <div class="mm-item">
                      <el-form-item label="公司電郵">
                        <el-input v-model="form.client2.email"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row " v-if="form.client2.type==2">
                    <div class="mm-item">
                      <el-form-item label="MSO 編號">
                        <el-input v-model="form.client2.mso_num"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="mm-row " v-if="form.client2.type==2">
                    <div class="mm-item">
                      <el-form-item label="MSO有效日期">
                        <el-date-picker v-model="form.client2.mso_num_date" type="date" placeholder="選擇日期" style="width:100%;">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </div>

              </div>
              <el-card class="box-card mb10" shadow="never" v-if="form.client2.type==1||form.client2.type==2">
                <div slot="header" class="clearfix">
                  <h3>股東 及 董事</h3>
                </div>
                <div class="text item">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                      <el-form-item label="股東姓名" required>
                        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                          <el-input v-model="form.client2.stockholder[0].name"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                      <el-form-item label="董事姓名" required>
                        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                          <el-input v-model="form.client2.director[0].name"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
              <el-card class="box-card mb10" shadow="never" v-if="form.client2.type==1||form.client2.type==2">
                <div slot="header" class="clearfix">
                  <h3>獲授權人</h3>
                </div>
                <div class="text item">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                      <el-form-item label="姓名" required>
                        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                          <el-input v-model="form.client2.authorizer[0].name"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                      <el-form-item label="電話號碼" required>
                        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="10" class="mr15">
                          <el-input v-model="form.client2.authorizer[0].phone"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>

                </div>
              </el-card>
              <div class="form-isheader-group">
                <div class="group-title">
                  <h3>會員文件</h3>
                </div>
                <div class="form-isheader-group-content">
                  <div v-if="form.client2.type==1||form.client2.type==2" class="notice" v-html="noticeContent"></div>
                  <uploadimage :fileDir="'customer'" :oldImageUrlList.sync="form.client2.customer_files_list" :imageUrlList.sync="form.client2.customer_upload_list" listType="picture-card"></uploadimage>
                </div>
              </div>
              <div class="form-isheader-group">
                <div class="group-title">
                  <h3>審查結果 Name Screening Result</h3>
                  <div class="shengchabon" v-if="examineStatus()">
                    <el-input-number class="mr15 pcshow2" v-model="form.client2.shengchascore" :min="0" :max="100" label="審查起始分數"></el-input-number>
                    <el-button @click="examine2" type="primary" plain>在線审查</el-button>
                  </div>
                </div>

                <div class="form-isheader-group-content">

                  <div style="margin-bottom: 20px;">
                    <div class="group-sub-title">
                      <h3>OFAC</h3>
                    </div>
                    <el-table empty-text="暫無數據" :data="form.client2.examinedata" border :header-cell-style="{background:'#FAFAFA'}">
                      <el-table-column label="Name" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Name</div>
                          <span>{{scope.row.name}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Address" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Address</div>
                          <span>{{scope.row.address}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Type" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Type</div>
                          <span>{{scope.row.type}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Program(s)" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Program(s)</div>
                          <span>{{scope.row.program}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="List" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">List</div>
                          <span>{{scope.row.list}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Score" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Score</div>
                          <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                          <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                          <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Url" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Url</div>
                          <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Query Time" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Query Time</div>
                          <span>{{scope.row.addtime}}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div style="margin-bottom: 20px;">
                    <div class="group-sub-title">
                      <h3>UNSC</h3>
                    </div>
                    <el-table empty-text="暫無數據" :data="form.client2.examinedataxml" border :header-cell-style="{background:'#FAFAFA'}">
                      <el-table-column label="Name" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Name</div>
                          <span>{{scope.row.name}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Type" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">type</div>
                          <span>{{scope.row.type}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Design" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">design</div>
                          <span>{{scope.row.design}}</span>
                        </template>
                      </el-table-column>

                      <el-table-column label="Date" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">date</div>
                          <span>{{scope.row.date}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Score" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Score</div>
                          <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                          <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                          <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Url" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">url</div>
                          <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                        </template>
                      </el-table-column>
                      <el-table-column label="Query Time" align="center">
                        <template slot-scope="scope">
                          <div class="phonecel">Query Time</div>
                          <span>{{scope.row.addtime}}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div style="margin-bottom: 20px;" v-if="examineStatus()">
                    <el-image style="width: 148px; height: 148px" :src="form.client2.examineimg" :preview-src-list="form.client2.examineimglist">
                    </el-image>
                  </div>
                  <uploadimage :fileDir="'customer'" :oldImageUrlList.sync="form.client2.review_files_list" :imageUrlList.sync="form.client2.review_upload_list" listType="picture-card"></uploadimage>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group" v-show="!nextbox">
          <div class="form-group-header">
            <div style="width: 120px;">
              <h3>買入交易</h3>
            </div>
            <div>
              <el-link icon="el-icon-circle-plus" class="mr15" @click="dialogbuytable=true">關聯交易單</el-link>
              <el-link icon="el-icon-circle-plus" class="mr15" @click="dialogbuybusiness=true">添加交易單</el-link>
              <el-link icon="el-icon-circle-plus">上傳交易EXCEL</el-link>
            </div>
          </div>
          <el-dialog title="未關聯買入記錄" :visible.sync="dialogbuytable" width="80%" :close-on-click-modal="false">
            <div v-if="dialogbuytable">
              <buyassoclate :order_id="0" is_linker="0" :visible.sync="dialogbuytable" @getids="getbuybusiness"></buyassoclate>
            </div>
          </el-dialog>

          <el-dialog title="添加買入交易" :visible.sync="dialogbuybusiness" width="80%" :close-on-click-modal="false">
            <div v-if="dialogbuybusiness">
              <buybusinessadd :store_id="form.store_id" :is_linker="0" :visible.sync="dialogbuybusiness" @getids="getbuybusiness"></buybusinessadd>
            </div>
          </el-dialog>
          <div class="form-group-content ">
            <div class="pagetablebox">
              <el-table empty-text="暫無數據" :data="buybusienes" border :header-cell-style="{background:'#FAFAFA'}">
                <el-table-column prop="businessnum" label="交易編號" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">交易編號</div>
                    <span :class="{'unlink':scope.row.status==5}">B{{scope.row.businessnum}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="addtime" label="時間" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">時間</div>
                    <span :class="{'unlink':scope.row.status==5}">{{scope.row.addtime}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="交易賬戶" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">交易賬戶</div>
                    <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==0">{{scope.row.store.name}}
                      {{scope.row.currency_short_name}}
                      {{scope.row.currency_name}} </div>
                    <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==1">
                      <div v-if="scope.row.bank_account.id">
                        <div>{{scope.row.bank_account.account_name}} {{addSpace(scope.row.bank_account.account_num)}} </div>
                        <div>{{scope.row.bank_account.bankname}} </div>
                        <div>{{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
                      </div>
                      <div v-else>
                        未關聯賬戶
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="買入貨幣" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">買入貨幣</div>
                    <div :class="{'unlink':scope.row.status==5}">{{scope.row.currency_short_name}} {{tomoney(scope.row.money)}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="hkd" label="折合港幣" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">折合港幣</div>
                    <span :class="{'unlink':scope.row.status==5}">HKD {{tomoney(scope.row.hkd)}}</span>
                    <template v-if="scope.row.business_type==2||scope.row.business_type==3"> (手續費)</template>
                  </template>
                </el-table-column>

                <el-table-column prop="status" label="狀態" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">狀態</div>
                    <statustext :status="scope.row.status"></statustext>
                  </template>
                </el-table-column>
                <el-table-column prop="hkd" label="操作" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">操作</div>
                    <span>
                      <el-link icon="el-icon-error" @click="delbuy(scope.row.id)"></el-link>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div class="form-group" v-show="!nextbox">
          <div class="form-group-header">
            <div>
              <h3 style="width: 120px;">賣出交易</h3>
            </div>
            <div>
              <el-link icon="el-icon-circle-plus" class="mr15" @click="dialogselltable=true">關聯交易單</el-link>
              <el-link icon="el-icon-circle-plus" class="mr15" @click="dialogsellbusiness=true">添加交易單</el-link>
              <el-link icon="el-icon-circle-plus">上傳交易EXCEL</el-link>
            </div>
          </div>
          <el-dialog title="未關聯賣出記錄" :visible.sync="dialogselltable" width="80%" :close-on-click-modal="false">
            <div v-if="dialogselltable">
              <sellassoclate :order_id="0" :ids="form.sellbusienes_ids" is_linker="0" :visible.sync="dialogselltable" @getids="getsellbusiness"></sellassoclate>
            </div>
          </el-dialog>
          <el-dialog title="添加賣出交易" :visible.sync="dialogsellbusiness" width="80%" :close-on-click-modal="false">
            <div v-if="dialogsellbusiness">
              <sellbusinessadd :store_id="form.store_id" :is_linker="0" :visible.sync="dialogsellbusiness" @getids="getsellbusiness"></sellbusinessadd>
            </div>
          </el-dialog>
          <div class="form-group-content">
            <div class="pagetablebox">
              <el-table empty-text="暫無數據" :data="sellbusienes" border :header-cell-style="{background:'#FAFAFA'}">
                <el-table-column prop="businessnum" label="交易編號" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">交易編號</div>
                    <span :class="{'unlink':scope.row.status==5}">S{{scope.row.businessnum}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="addtime" label="時間" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">時間</div>
                    <span :class="{'unlink':scope.row.status==5}">{{scope.row.addtime}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="交易賬戶" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">交易賬戶</div>
                    <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==0">{{scope.row.store.name}}
                      {{scope.row.currency_short_name}}
                      {{scope.row.currency_name}} </div>
                    <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==1">
                      <div v-if="scope.row.bank_account.id">
                        <div>{{scope.row.bank_account.account_name}} {{addSpace(scope.row.bank_account.account_num)}} </div>
                        <div>{{scope.row.bank_account.bankname}} </div>
                        <div>{{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
                      </div>
                      <div v-else>
                        未關聯賬戶
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="money" label="賣出貨幣" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">賣出貨幣</div>
                    <span :class="{'unlink':scope.row.status==5}">{{scope.row.currency.short_name}} {{tomoney(scope.row.money)}}</span>
                    <template v-if="scope.row.business_type==2||scope.row.business_type==3"> (手續費)</template>
                  </template>
                </el-table-column>
                <el-table-column prop="hkd" label="折合港幣" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">折合港幣</div>
                    <span :class="{'unlink':scope.row.status==5}">HKD {{tomoney(scope.row.hkd)}}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="status" label="狀態" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">狀態</div>
                    <statustext :status="scope.row.status"></statustext>
                  </template>
                </el-table-column>
                <el-table-column prop="hkd" label="操作" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">操作</div>
                    <span>
                      <el-link icon="el-icon-error" @click="delsell(scope.row.id)"></el-link>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div v-show="nextbox" class="mb10">
          <div class="form-isheader-group">
            <div class="group-title">
              <h3>上傳附件</h3>
            </div>
            <div class="form-isheader-group-content">
              <uploadimage :fileDir="'compliance'" :imageUrlList.sync="form.files_list" listType="picture-card"></uploadimage>
            </div>
          </div>
          <div class="form-isheader-group">
            <div class="group-title">
              <h3>盡職審查</h3>
            </div>
            <div class="form-isheader-group-content">
              <div class="mm-row">
                <div class="mm-col">
                  <div class="mm-item-c">
                    <div class="mm-label" style="padding-left:0">風險評分:</div>
                    <el-switch v-model="form.risk" active-value="1" inactive-value="0" active-color="#ff4949" inactive-color="#e6e6e6" active-text="高風險" inactive-text="低風險"></el-switch>
                  </div>
                </div>
                <div class="mm-col">
                  <div class="mm-item-c">
                    <div class="mm-label" style="padding-left:0">懷疑個案:</div>
                    <el-switch v-model="form.doubt" active-value="1" inactive-value="0" active-color="#ff4949" inactive-color="#e6e6e6" active-text="是" inactive-text="否"></el-switch>
                  </div>
                </div>
                <div class="mm-col">
                  <div class="mm-item-c">
                    <div class="mm-label" style="padding-left:0">舉報個案:</div>
                    <el-switch v-model="form.impeach" active-value="1" inactive-value="0" active-color="#ff4949" inactive-color="#e6e6e6" active-text="是" inactive-text="否"></el-switch>
                  </div>
                </div>
              </div>
              <reviewlist :showType="reviet_type" :resultData.sync="form.inspect"></reviewlist>
            </div>
          </div>
          <div class="form-isheader-group">
            <div class="group-title">
              <h3>備注</h3>
            </div>
            <div class="form-isheader-group-content">
              <div class="mm-col">
                <div class="mm-item-c">
                  <el-input v-model="form.remarks" type="textarea"></el-input>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="form-submit">
          <el-button v-show="!nextbox" type="primary" @click="nextstep()">下一步</el-button>
          <el-button v-show="nextbox" type="primary" @click="nextbox=false">上一步</el-button>
          <el-button v-show="nextbox" type="primary" @click="beforeSubmit()">提交</el-button>
        </div>

      </el-form>

    </div>
  </div>
</template>

<script>
import countryselect from '@/components/CountrySelect.vue';
import uploadimage from '@/components/Uploadimage.vue';
import reviewlist from "@/components/ReviewList.vue";
import buybusinessadd from "@/components/BuyBusinessAdd.vue";
import sellbusinessadd from "@/components/SellBusinessAdd.vue";
import buyassoclate from "./components/BuyBusienesAssoclate.vue";
import sellassoclate from "./components/SellBusienesAssoclate.vue";
import customerlist from "./components/CustomerList.vue";
import statustext from "@/components/StatusText.vue"
export default {
  components: {
    countryselect,
    uploadimage,
    reviewlist,
    buyassoclate,
    sellassoclate,
    customerlist,
    buybusinessadd,
    sellbusinessadd,
    statustext,

  },
  data () {
    return {
      loading: false,
      dialogbuytable: false, // 關聯買入訂單選擇列表
      dialogselltable: false, // 關聯賣出訂單選擇列表
      dialogbuybusiness: false, // 添加買入交易訂單
      dialogsellbusiness: false, // 添加賣出交易訂單
      dialogcustomerlist: false,
      dialogcustomerlist2: false,
      reviet_type: 0, // 合規審查類型
      nextbox: false,
      showpicurl: '',
      showpicbox: false,
      value1: 0,
      ordertype: -1,
      storelist: [],
      sectorlist: [],
      noticeContent: `<h3>上傳要求:</h3>
                    董事、股東、獲授權代表的身分證或護照<br>
                    董事、股東、獲授權代表的住址證明<br>
                    商業登記證<br>
                    公司註冊證明書<br>
                    公司更改名稱證明書<br>
                    公司組織章程及大綱<br>
                    周年申報表<br>
                    由董事簽名認證的擁有權結構圖<br>
                    重要控制人登記冊<br>
                    書面授權或董事會的決議案<br>
                    開戶表格<br>
                    註冊資料證明書 (或稱: 職權證明書)<br>
                    經營金錢服務的牌照<br>
                    打擊洗錢及恐怖分子資金籌集政策<br>
                    資金來源<br>
                    財富來源<br>`,
      timer: '',
      timer2: '',
      initcustomer: {
        id: 0,
        type: '0',
        country_id: "",
        shengchascore: 95,
        countryname: "",
        customer_upload_list: [],
        review_upload_list: [],
        customer_files_list: [],
        review_files_list: [],
        inspect: {},
        email: "", // 公司郵箱
        name: "", // 名稱
        ename: "", // 英文名稱
        appellations: "", //稱爲
        address: "", // 住址
        phone: "", // 公司電話/電話號碼
        card: "", // 身份証號碼
        agent: 0, // 是否使用代理
        company_num: "", // 公司編號
        company_card: "", // 商業登記號碼
        company_card_date: "", // 商業登記號碼有效日期
        company_type: "", // 業務性質
        mso_num: "", // MSO編號
        mso_num_date: "", // MSO編號有效期
        // 股東和董事列表
        stockholder: [{
          name: ""
        }],
        // 董事
        director: [{
          name: ''
        }],
        // 獲受人信息 
        authorizer: [{
          name: "",
          phone: ""
        }],
        examineimg: '',
        examineimglist: [],
        examinedata: [],
        examineimgpath: '',
        examinedataxml: [],
      },
      form: {
        buybusienes_ids: [],
        sellbusienes_ids: [],
        is_remitter: true, // 匯款人和指使人是同一人
        store_id: '',
        sector_id: '',
        ordertype: '0',
        client: {},
        client2: {},
        files_list: [],
        risk: 0,
        doubt: 0,
        impeach: 0,
        inspect: {},
        remarks: ''
      },
      sellbusienes: [],
      buybusienes: [],
    };
  },
  methods: {
    beforeSubmit () {
      // 必填資料驗證
      let assignor = this.form.client;
      if (!this.customer_check(assignor)) {
        return false;
      }

      // 檢查是匯款人和指示人不一致
      if (!this.form.is_remitter) {
        let assignor2 = this.form.client2;
        if (!this.customer_check(assignor2)) {
          return false;
        }
      };
      this.fromsumbit('form');
    },
    // 會員資料檢查
    customer_check (assignor) {
      if (assignor.type == 0) {
        if (assignor.name == '' || assignor.phone == '' || assignor.country_id == '') {
          let notice = '客戶資料中帶*號選項必選填寫！';
          if (assignor.name == '') {
            notice = '客戶資料中客戶姓名必須填寫！';
          } else if (assignor.phone == '') {
            notice = '客戶資料中客戶電話號碼必須填寫！';
          } else if (assignor.country_id == '') {
            notice = '客戶資料中客戶國籍必須選擇！';
          }
          this.$notify.error({
            title: 'Error',
            message: notice,
            offset: 160
          });
          return false;
        }
      } else if (assignor.type == 1) {
        if (assignor.name == '' || assignor.phone == '' || assignor.company_card == '' || assignor.company_card_date == '' || assignor.company_type == '' || assignor.stockholder[0].name == '' || assignor.director[0].name == '' || assignor.authorizer[0].name == '' || assignor.authorizer[0].phone == '') {
          let notice = '客戶資料中帶*號選項必選填寫！';
          if (assignor.country_id == '') {
            notice = '客戶資料中公司註冊地必須選擇！';
          } else if (assignor.name == '') {
            notice = '客戶資料中公司名稱必須填寫！';
          } else if (assignor.company_card == '') {
            notice = '客戶資料中商業登記證號碼必須填寫！';
          } else if (assignor.company_card_date == '') {
            notice = '客戶資料中商業登記證號碼有效日期必須填寫！';
          } else if (assignor.company_type == '') {
            notice = '客戶資料中業務性質必須填寫！';
          } else if (assignor.phone == '') {
            notice = '客戶資料中公司電話號碼必須填寫！';
          } else if (assignor.stockholder[0].name == '') {
            notice = '客戶資料中股東姓名必須填寫！';
          } else if (assignor.director[0].name == '') {
            notice = '客戶資料中董事姓名必須填寫！';
          } else if (assignor.authorizer[0].name == '') {
            notice = '客戶資料中獲授權人姓名必須填寫！';
          } else if (assignor.authorizer[0].phone == '') {
            notice = '客戶資料中獲授權人電話號碼必須填寫！';
          }


          this.$notify.error({
            title: 'Error',
            message: notice,
            offset: 160
          });
          return false;
        }
      } else if (assignor.type == 2) {
        if (assignor.name == '' || assignor.phone == '' || assignor.company_card == '' || assignor.company_card_date == '' || assignor.company_type == '' || assignor.mso_num == '' || assignor.mso_num_date == '' || assignor.stockholder[0].name == '' || assignor.director[0].name == '' || assignor.authorizer[0].name == '' || assignor.authorizer[0].phone == '') {
          let notice = '客戶資料中帶*號選項必選填寫！';
          if (assignor.country_id == '') {
            notice = '客戶資料中公司註冊地必須選擇！';
          } else if (assignor.name == '') {
            notice = '客戶資料中公司名稱必須填寫！';
          } else if (assignor.company_card == '') {
            notice = '客戶資料中商業登記證號碼必須填寫！';
          } else if (assignor.company_card_date == '') {
            notice = '客戶資料中商業登記證號碼有效日期必須填寫！';
          } else if (assignor.company_type == '') {
            notice = '客戶資料中業務性質必須填寫！';
          } else if (assignor.phone == '') {
            notice = '客戶資料中公司電話號碼必須填寫！';
          } else if (assignor.mso_num == '') {
            notice = '客戶資料中MSO編號必須填寫！';
          } else if (assignor.mso_num_date == '') {
            notice = '客戶資料中MSO有效日期必須填寫！';
          } else if (assignor.stockholder[0].name == '') {
            notice = '客戶資料中股東姓名必須填寫！';
          } else if (assignor.director[0].name == '') {
            notice = '客戶資料中董事姓名必須填寫！';
          } else if (assignor.authorizer[0].name == '') {
            notice = '客戶資料中獲授權人姓名必須填寫！';
          } else if (assignor.authorizer[0].phone == '') {
            notice = '客戶資料中獲授權人電話號碼必須填寫！';
          }

          this.$notify.error({
            title: 'Error',
            message: notice,
            offset: 160
          });
          return false;
        }
      }
      return true;
    },
    examine1 () {
      let ename = this.form.client.ename;
      let country_id = this.form.client.country_id;
      if (!ename) {
        this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 請填寫審查英文姓名</div>', '提示', {
          dangerouslyUseHTMLString: true
        });
        return false;
      }
      let card = this.form.client.card;
      // 企業或行家時
      if (this.form.client.type != 0) {
        card = this.form.client.company_card;
      }
      let address = this.form.client.address;
      let score = this.form.client.shengchascore;
      this.loading = true;
      this.form.client.examineimg = '',
        this.form.client.examineimglist = [],
        this.post('api/order/examine', {
          ename,
          country_id,
          card,
          address,
          score
        })
          .then(res => {
            this.loading = false;

            if (res.status == 'error') {
              this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 查詢失敗，請嘗試添加國籍，身份證，地址信息</div>', '提示', {
                dangerouslyUseHTMLString: true
              });
              return false;
            } else if (res.status == 'success') {
              this.form.client.examinedata = res.data;
              this.form.client.examinedataxml = res.examinedataxml;
              this.form.client.examineimg = res.thumburl;
              this.form.client.examineimgpath = res.thumburl2;
              this.form.client.examineimglist.push(res.thumburl);
            }

          }).catch(error => {
            this.loading = false;
            this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 查詢失敗，請求超時</div>', '提示', {
              dangerouslyUseHTMLString: true
            });
            return false;
          });

    },
    examine2 () {
      let ename = this.form.client2.ename;
      let country_id = this.form.client2.country_id;
      if (!ename) {
        this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 請填寫審查英文姓名</div>', '提示', {
          dangerouslyUseHTMLString: true
        });
        return false;
      }
      let card = this.form.client2.card;
      // 企業或行家時
      if (this.form.client2.type != 0) {
        card = this.form.client2.company_card;
      }
      let address = this.form.client2.address;
      let score = this.form.client2.shengchascore;
      this.loading = true;
      this.form.client2.examineimg = '';
      this.form.client2.examineimglist = [];
      this.post('api/order/examine', {
        ename,
        country_id,
        card,
        address,
        score
      })
        .then(res => {
          this.loading = false;
          if (res.status == 'error') {
            this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 查詢失敗，請嘗試添加國籍，身份證，地址信息</div>', '提示', {
              dangerouslyUseHTMLString: true
            });
            return false;
          } else if (res.status == 'success') {
            this.form.client2.examinedataxml = res.examinedataxml;
            this.form.client2.examinedata = res.data;
            this.form.client2.examineimg = res.thumburl;
            this.form.client.examineimgpath = res.thumburl2;
            this.form.client2.examineimglist.push(res.thumburl);
          }

        }).catch(error => {
          this.loading = false;
          this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 查詢失敗，請求超時</div>', '提示', {
            dangerouslyUseHTMLString: true
          });
          return false;
        });

    },
    nextstep () {
      // 必填資料驗證
      let assignor = this.form.client;
      if (!this.customer_check(assignor)) {
        return false;
      }

      // 檢查是匯款人和指示人不一致
      if (!this.form.is_remitter) {
        let assignor2 = this.form.client2;
        if (!this.customer_check(assignor2)) {
          return false;
        }
      };
      this.nextbox = true
    },
    openbyurl (routerName) {
      console.log(this.orderDetail);
      let routeData = this.$router.resolve({
        name: routerName,
        params: {
          data: this.orderDetail
        }
      });
      window.open(routeData.href, '_blank');
    },
    customerinit (type) {
      if (type == 1) {
        this.form.client = JSON.parse(JSON.stringify(this.initcustomer));
        this.timer = new Date().getTime();
      } else if (type == 2) {
        this.form.client2 = JSON.parse(JSON.stringify(this.initcustomer));
        this.timer2 = new Date().getTime();
      } else {
        this.form.client = JSON.parse(JSON.stringify(this.initcustomer));
        this.form.client2 = JSON.parse(JSON.stringify(this.initcustomer));
        this.timer = new Date().getTime();
        this.timer2 = new Date().getTime();
      }

    },
    gobyurl (routerName) {
      this.$router.push({
        name: routerName
      })
    },
    getbuybusiness (ids) {
      this.post('api/business/getbyids', {
        ids
      })
        .then(res => {
          if (res.length > 0) {
            this.buybusienes = res;
            let ids = [];
            this.buybusienes.some(item => {
              ids.push(item.id);
            })
            this.form.buybusienes_ids = ids;
          }
        }).catch(error => { });
    },
    getsellbusiness (ids) {
      this.post('api/business/getbyids', {
        ids
      })
        .then(res => {
          if (res.length > 0) {
            this.sellbusienes = res;
            let ids = [];
            this.sellbusienes.some(item => {
              ids.push(item.id);
            })
            this.form.sellbusienes_ids = ids;
          }
        })
        .catch(error => { });
    },
    delsell (id) {
      this.form.sellbusienes_ids = [];
      this.sellbusienes = this.sellbusienes.filter(item => {
        if (item.id != id) {
          this.form.sellbusienes_ids.push(item.id);
          return true;
        }
      })
    },
    delbuy (id) {
      this.form.buybusienes_ids = [];
      this.buybusienes = this.buybusienes.filter(item => {
        if (item.id != id) {
          this.form.buybusienes_ids.push(item.id);
          return true;
        }
      })
    },
    pageback () {
      this.$router.go(-1);
    },
    delpic (file, fileList) {
      console.log(file, fileList);
    },
    viewpic (file) {
      this.showpicurl = file.url;
      this.showpicbox = true;
    },
    getstore () {
      let mso_id = sessionStorage.getItem('mso_id');
      this.post('/api/order/getstore', {
        mso_id
      })
        .then(response => {
          if (response.length > 0) {
            this.storelist = response;
            this.form.store_id = response[0].id;
          }
        })
        .catch(error => { });
    },
    getsector () {
      let mso_id = sessionStorage.getItem('mso_id');
      let staff_id = sessionStorage.getItem('staff_id');
      this.post('/api/sector/usersector', {
        mso_id,
        staff_id,
      }).then(response => {
        if (response.length > 0) {
          this.sectorlist = response;
          this.form.sector_id = response[0].id;
        }
      }).catch(error => { });
    },
    fromsumbit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let data = this.form;

          // this.loading = true;
          let mso_id = sessionStorage.getItem('mso_id');
          data.mso_id = mso_id;
          data.staff_id = sessionStorage.getItem('staff_id');
          this.post('/api/order/orderadd', data).then((res) => {
            if (res.status == 'success') {
              this.$message({
                showClose: true,
                message: '添加成功',
                type: 'success',
                onClose: (() => {
                  this.loading = false;
                })
              });
              this.pageback();
            } else {
              this.$message({
                showClose: true,
                message: '添加失敗',
                type: 'error'
              });
              this.loading = false
            };
          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        }
      });
    }
  },
  created () {
    this.getstore();
    this.getsector();
    this.customerinit();
  },
  watch: {
    'form.ordertype' (val) {
      if (val == 1) {
        this.reviet_type = 2;
      } else {
        this.reviet_type = 0;
      }
    },
    'form': { // 動態監控利率變化
      handler: function (newVal, oldVal) {
        // console.log(newVal);
      },
      deep: true
    },
  }

};
</script>
<style scoped>
.shengchabon {
  margin-left: 20px;
}

.mb10 {
  margin-bottom: 10px;
}

.mm-item {
  display: block;
  flex: 0 50%;
}

.notice {
  margin-bottom: 20px;
}

.mm-row {
  padding: 10px 0px;
}

.mm-item-c {
  display: flex;
  align-items: center;
}

.chooseuserbox {
  padding-bottom: 20px;
  position: absolute;
}

.pctitle {
  display: flex;
  align-items: center;
}

@media screen and (max-width: 1024px) {
  .chooseuserbox {
    padding-bottom: 20px;
    position: relative;
  }

  .mm-item {
    display: block;
    flex: 1 1 100%;
    justify-content: space-between;
  }

  .pctitle {
    display: block;
  }

  .mm-row {
    display: block;
    padding: 0 !important;
  }
}
</style>
